import React from 'react'
import { IProductBase, IProductInCart } from 'product/IProduct'
import { Row, Col } from 'react-bootstrap'
import CartProductActions from './CartProductActions'
import ProductListItemView from '../product_list_view/ProductListItemView'
import { TOneItemCallback } from 'HttpRequests'

interface IProductListProps {
  products: IProductInCart[]
  isLoading: boolean
  onRemoveProduct: TOneItemCallback<IProductBase>
  onChangeProductQuantity: (product: IProductBase, quantity: number) => void
}

const CartProductList: React.FC<IProductListProps> = ({ products, ...others }) => {
  return (
    <>
      {products.map((product) => {
        return (
          <Row key={product.product_id} className='border-t-full py-row'>
            <Col xs={12}>
              <ProductListItemView product={product} showDescription='accordion'>
                <CartProductActions product={product} {...others} />
              </ProductListItemView>
            </Col>
          </Row>
        )
      })}
    </>
  )
}
export default CartProductList
